import React from 'react';
import I18n from 'i18n-js';
import { TCITooltip } from '@/components/ui/Tooltip';
import { CIRCLE_ICON_CLASS, ACTION_BAR_BTN_SHADOW } from '../../GoToButton';

type ActionBarButtonType = {
  tag: string
  icon: string;
  onClick?: () => void;
};

export const ACTION_BAR_BTN_BG = 'rgba(52, 2, 91, 0.05)';

const ActionBarButton = ({ icon, tag, onClick } : ActionBarButtonType) => (
  <TCITooltip>
    <TCITooltip.Trigger asChild>
      <button
        aria-haspopup="dialog"
        aria-label={I18n.t(tag)}
        className={CIRCLE_ICON_CLASS}
        style={{ backgroundColor: ACTION_BAR_BTN_BG, boxShadow: ACTION_BAR_BTN_SHADOW }}
        type="button"
        onClick={onClick}
      >
        <img aria-hidden alt="" src={icon} />
      </button>
    </TCITooltip.Trigger>
    <TCITooltip.Content>
      {I18n.t(tag)}
    </TCITooltip.Content>
  </TCITooltip>
);
export default ActionBarButton;
